"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Attachment = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const __1 = require("../../../../../../..");
const StyledFileName = styled_components_1.default.div `
    display: flex;
    min-width: 0;
`;
const Attachment = ({ displayName, downloadUrl, previewUrl, className, }) => {
    return (react_1.default.createElement(__1.Card, { className: className, isElevated: false, spacing: 1.5 },
        react_1.default.createElement(__1.StackPanel, { orientation: "horizontal", horizontalContentAlignment: "space-between", verticalContentAlignment: "center", gutter: 1 },
            react_1.default.createElement(StyledFileName, null,
                react_1.default.createElement(__1.Icon, { name: "Paperclip", size: 2, props: { className: "mr-1 flex-shrink-0" } }),
                react_1.default.createElement(__1.Text, { as: "span", variant: "note", skinny: true, props: {
                        title: displayName,
                        className: "text-truncate",
                    } }, displayName)),
            react_1.default.createElement(__1.Text, { as: "div", variant: "note" }, previewUrl ? (react_1.default.createElement("a", { target: "_blank", rel: "noreferrer noopener", href: previewUrl }, "Preview")) : (react_1.default.createElement("a", { target: "_blank", rel: "noreferrer noopener", href: downloadUrl, download: true }, "Download"))))));
};
exports.Attachment = Attachment;
//# sourceMappingURL=Attachment.js.map